import { Button } from '@/components/ui/button'
import Icon from '@/components/shared/icons'
import { ClickInterface } from '@/entities/app/interfaces' 
import React from 'react'

const ButtonMore: React.FC<ClickInterface> = ({click}) => {
	return (
		<Button
			mt='2'
            mb='2'
			p='2'
			border='0.1px solid'
			borderColor='black'
			borderRadius='lg'
			bg='transparent'
			onClick={click}
		>
			<Icon icon='more' size='xl' color='black' />
		</Button>
	)
}

export default ButtonMore
